import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import Icon from '@material-ui/core/Icon'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import Button from '@material-ui/core/Button'
import VideocamIcon from '@material-ui/icons/Videocam'
import EditIcon from '@material-ui/icons/Edit'
import VideDescDialog from '../ViewDesc'

interface Column {
  id: string
  subId?: string
  label: string
  minWidth?: number
  align?: 'right'
  format?: (value: number) => string
}

const skipSortField: string[] = ['actions', 'sequence', 'description']

const columns: Column[] = [
  { id: 'actions', label: 'Actions', minWidth: 100 },
  { id: 'name', label: 'Name', minWidth: 100 },
  { id: 'isAvailable', label: 'Available?', minWidth: 100 },
  { id: 'sequence', label: 'Sequence', minWidth: 100 },
  { id: 'videoType', label: 'Video Type', minWidth: 100 },
  { id: 'description', label: 'Description', minWidth: 100 },
]

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
})

interface IStickHeaderTableProps {
  videos: any[],
  sortBy: any | null,
  filter: any | null,
  order: any | null,
  orderBy: any | null,
  setOrder: () => void,
  setOrderBy: () => void,
  setFilter: () => void,
  setSortBy: () => void,
  handleVideoClick: () => void,
  handleEditVideo: () => void,
  populateVideoMaterials: () => void,
}

const ListVideo: React.FC<IStickHeaderTableProps> = ({ order, orderBy, setOrder, setOrderBy, sortBy, filter, setSortBy, setFilter, videos, handleVideoClick, handleEditVideo, populateVideoMaterials }) => {
  const classes = useStyles()
  const [openViewDescDialog, setOpenViewDescDialog] = React.useState(false)
  const [targetName, setTargetName] = React.useState('')
  const [targetDesription, setTargetDesription] = React.useState('')
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)

  const [operator, setOperator] = useState("*")
  const [field, setField] = useState("-SELECT-")
  const [value, setValue] = useState("")
  const [errorField, setErrorField] = useState(false)
  const [errorValue, setErrorValue] = useState(false)

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  const handleVideDescClose = (vid: any) => {
    setTargetName('')
    setTargetDesription('')
    setOpenViewDescDialog(false)
  }

  const formatField = (column: Column, value: any, row: any) => {
    let result = value
    switch (column.id) {
      case 'description':
        if (value) {
          result = (
            <div>
              <span>{`${value.substr(0, 20)}...`}</span>
              <span onClick={() => {
                setTargetName(row.name)
                setTargetDesription(row.description)
                setOpenViewDescDialog(true)
              }} style={{ color: 'blue', cursor: 'pointer' }}>see more</span>
            </div>

          )
        }
        break
      case 'videoType':
        switch (value) {
          case 'MATERIAL':
            result = 'Material'
            break
          case 'SUPPORTMATERIAL':
            result = 'Support Material'
            break
        }
        break
      case 'isAvailable':
        result = value ? 'Yes' : 'No'
        break
      case 'actions':
        result = (
          <>
            <Button startIcon={<VideocamIcon />} style={{ marginRight: 10 }} disabled={!row.isAvailable} variant="contained" size="small" color="secondary" onClick={() => handleVideoClick(row.name, row.videoURL)}>
              Watch
            </Button>
            {/* <Button startIcon={<EditIcon />} variant="contained" size="small" color="primary" onClick={() => handleEditVideo(row)}>
              Edit
            </Button> */}
          </>
        )
        break
    }

    return result
  }

  return (
    <>
      {/* <form style={{
        border: '1px solid #dedede',
        padding: '20px',
        borderRadius: '5px',
        background: '#fff',
        width: '400px'
      }} noValidate autoComplete="off">
        <FormControl fullWidth>
          <InputLabel htmlFor="Operator">Field</InputLabel>
          <Select
            native
            value={field}
            onChange={e => {
              const val = e.currentTarget.value
              setField(val)
              setErrorField(val === '')
              setValue('')
              setErrorValue(false)
            }}
            inputProps={{
              name: 'field',
              id: 'field',
            }}
            fullWidth
          >
            <option value="-SELECT-">-Select Field-</option>
            <option value="Name">Name</option>
            <option value="VideoType">Video Type</option>
          </Select>
          {errorField && <span style={{ color: 'red', fontSize: 12 }}>Field is required</span>}
        </FormControl>
        <div style={{ marginBottom: 20 }} />
        {field === 'VideoType' ? (<FormControl fullWidth>
          <InputLabel htmlFor="Value">Value</InputLabel>
          <Select
            native
            value={value}
            onChange={e => {
              const val = e.currentTarget.value ?? ''
              setValue(val)
              setErrorValue(val === '' || val === '-SELECT-')
            }}
            inputProps={{
              name: 'value',
              id: 'value',
            }}
            fullWidth
          >
            <option value="-SELECT-">-Select Value-</option>
            <option value="MATERIAL">Material</option>
            <option value="SUPPORTMATERIAL">Support Material</option>
          </Select>
          {errorValue && <span style={{ color: 'red', fontSize: 12 }}>Value is required</span>}
        </FormControl>) : (<FormControl fullWidth>
          <TextField
            autoFocus
            id="Value"
            label="Value"
            value={value}
            fullWidth
            inputProps={{ maxLength: 50, shrink: true, }}
            onChange={e => {
              const val = e.currentTarget.value ?? ''
              setValue(val)
            }}
          />
          {errorValue && <span style={{ color: 'red', fontSize: 12 }}>Value is required</span>}
        </FormControl>)}
        <div style={{ marginBottom: 20 }} />
        <FormControl fullWidth>
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
            <Button variant="contained" startIcon={<Icon>search</Icon>} onClick={async () => {
              const isFieldEmpty = field === '-SELECT-'
              setErrorField(isFieldEmpty)
              if (isFieldEmpty) return

              const isValueEmpty = value === '' || value === '-SELECT-'
              setErrorValue(isValueEmpty)
              if (isValueEmpty) return

              const filterObj = {
                name: field,
                operator,
                value: value.trim()
              }

              setFilter(filterObj)
              setPage(0)
              await populateVideoMaterials(filterObj, sortBy)
            }} color="primary">
              Search
            </Button>
            <div style={{ marginRight: 20 }} />
            <Button variant="contained" startIcon={<Icon>clear</Icon>} onClick={async () => {
              setValue("")
              setField("-SELECT-")
              setFilter(prev => null)
              setPage(0)
              await populateVideoMaterials(null, sortBy)
            }} color="secondary">
              Clear
            </Button>
          </div>
        </FormControl>
      </form > */}
      <div style={{ marginBottom: 20 }} />
      <Paper className={classes.root}>
        {openViewDescDialog && <VideDescDialog open={openViewDescDialog} name={targetName} handleClose={handleVideDescClose} description={targetDesription} />}
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column, idx) => (
                  <TableCell
                    key={`column_${idx + 1}`}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {skipSortField.indexOf(column.id) == -1 ? <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : 'asc'}
                      onClick={async (event) => {
                        const isAsc = orderBy === column.id && order === 'asc'
                        setOrder(isAsc ? 'desc' : 'asc')
                        setOrderBy(column.id)
                        const sortByObj = {
                          sortField: column.id,
                          sortDirection: isAsc ? 0 : 1
                        }
                        setSortBy(sortByObj)
                        await populateVideoMaterials(filter, sortByObj)
                      }}
                    >
                      {column.label}
                      {orderBy === column.id ? (
                        <span className={classes.visuallyHidden}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </span>
                      ) : null}
                    </TableSortLabel> : column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {videos.map((row) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                      {columns.map((column, idx) => {
                        const value = column.subId ? row[column.id][column.subId] : row[column.id]
                        return (
                          <TableCell key={`column_${idx + 1}`} align={column.align}>
                            {formatField(column, value, row)}
                          </TableCell>
                        )
                      })}
                    </TableRow>
                  )
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={videos.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  )
}

export default ListVideo